import React from "react";

export default function DateSvg({ color = "#3C3C43", className = "" }) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1482_11852)">
        <path
          d="M14.7339 1.25H13.9839V0H12.7339V1.25H4.48389V0H3.23389V1.25H2.48389C1.45001 1.25 0.608887 2.09113 0.608887 3.125V14.125C0.608887 15.1589 1.45001 16 2.48389 16H14.7339C15.7678 16 16.6089 15.1589 16.6089 14.125V3.125C16.6089 2.09113 15.7678 1.25 14.7339 1.25ZM15.3589 14.125C15.3589 14.4696 15.0785 14.75 14.7339 14.75H2.48389C2.13926 14.75 1.85889 14.4696 1.85889 14.125V5.875H15.3589V14.125ZM15.3589 4.625H1.85889V3.125C1.85889 2.78038 2.13926 2.5 2.48389 2.5H3.23389V3.75H4.48389V2.5H12.7339V3.75H13.9839V2.5H14.7339C15.0785 2.5 15.3589 2.78038 15.3589 3.125V4.625Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M4.23389 7.1875H2.98389V8.4375H4.23389V7.1875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M6.73389 7.1875H5.48389V8.4375H6.73389V7.1875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M9.23389 7.1875H7.98389V8.4375H9.23389V7.1875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M11.7339 7.1875H10.4839V8.4375H11.7339V7.1875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M14.2339 7.1875H12.9839V8.4375H14.2339V7.1875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M4.23389 9.6875H2.98389V10.9375H4.23389V9.6875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M6.73389 9.6875H5.48389V10.9375H6.73389V9.6875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M9.23389 9.6875H7.98389V10.9375H9.23389V9.6875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M11.7339 9.6875H10.4839V10.9375H11.7339V9.6875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M4.23389 12.1875H2.98389V13.4375H4.23389V12.1875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M6.73389 12.1875H5.48389V13.4375H6.73389V12.1875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M9.23389 12.1875H7.98389V13.4375H9.23389V12.1875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M11.7339 12.1875H10.4839V13.4375H11.7339V12.1875Z"
          fill={color}
          fillOpacity="0.6"
        />
        <path
          d="M14.2339 9.6875H12.9839V10.9375H14.2339V9.6875Z"
          fill={color}
          fillOpacity="0.6"
        />
      </g>
      <defs>
        <clipPath id="clip0_1482_11852">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.608887)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
